import { SvgIcon, SvgIconProps } from '@mui/material'
import { NovaColours, useAppContext } from '@novafuturltd/core'

export const CategoriesIcon = (props: SvgIconProps) => {
  const { mode } = useAppContext()
  const defaultFill = NovaColours.N040[mode]

  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2L6.5 11H17.5L12 2ZM17.5 22C19.9853 22 22 19.9853 22 17.5C22 15.0147 19.9853 13 17.5 13C15.0147 13 13 15.0147 13 17.5C13 19.9853 15.0147 22 17.5 22ZM11 13.5H3V21.5H11V13.5Z"
        fill={defaultFill}
      />
    </SvgIcon>
  )
}

export default CategoriesIcon
